import { of } from './storage.js';

/** @type {import('./storage').Storage<string>} */
const storage = of('z_session_id', {
  duration: /* 30 minutes */30 * 60 * 1000
});
function generate() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}
function useSessionId() {
  let sessionId = storage.retrieve();
  if (!sessionId) {
    sessionId = generate();
    storage.store(sessionId);
  }
  return sessionId;
}

export { useSessionId as default, storage };
